import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export const groupsReportAbuseCapability: Capability = {
    isEnabled: (mailboxInfo?: MailboxInfo) => {
        return isConsumer(undefined, mailboxInfo);
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return isGlobalFeatureEnabled('grp-ReportAbuseEnabled');
    },
};
